export default __webpack_public_path__ + "static/cu-a25817cd1902003da253bdbc962c6add.svg";